/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'next/router'; // eslint-disable-line
import dynamic from 'next/dynamic';
import { getIsMiniPDPEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import ProductDetailContainer from '../ProductDetail/ProductDetail.container';

const ProductDetailContainerMiniPDP = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "mini-pdp" */ '../ProductDetailMiniPDP/ProductDetailMiniPDP.container'
    ),
  { ssr: false }
);

class ProductDetailContainerWrapper extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isFullDetailClick: false,
    };
  }

  componentDidMount() {}

  componentDidUpdate() {}

  render() {
    const { isMiniPDP, isMiniPDPEnabled } = this.props;

    if (isMiniPDPEnabled && isMiniPDP) {
      return <ProductDetailContainerMiniPDP />;
    }
    return <ProductDetailContainer />;
  }
}

function mapStateToProps(state) {
  return { isMiniPDPEnabled: getIsMiniPDPEnabled(state) };
}

function mapDispatchToProps() {
  return {};
}

ProductDetailContainerWrapper.propTypes = {};

ProductDetailContainerWrapper.defaultProps = {};

const PDPConnectComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductDetailContainerWrapper);

const PDPRouterWrapper = withRouter(PDPConnectComponent);

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(PDPRouterWrapper);
